import React from 'react';
import LegalLayout from './legallayout';
import { Helmet } from 'react-helmet-async';

const Refund = () => (
  <LegalLayout title="Refund & Cancellation" lastUpdated="March 22, 2026">

    <Helmet>
        <h1>Refund & Cancellation | Sitemanifest</h1>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <section>
      <h2 className="text-xl font-bold text-black mb-4">1. Subscription Terms</h2>
      <p>
        Sitemanifest is a subscription-based SaaS. By signing up, you agree to be billed 
        automatically on a recurring basis. You can cancel your subscription at any time 
        directly through your Business Dashboard.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">2. 14-Day Money-Back Guarantee</h2>
      <p>
        We want you to be fully satisfied with Sitemanifest. We offer a <strong>14-day money-back guarantee</strong> for all new Business Users. 
        If our platform does not meet your expectations for any reason, you may 
        request a full refund within the first 14 days of your initial purchase.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">3. Refund Requests</h2>
      <p>
        Refund requests made within the 14-day window are processed "no-questions-asked." 
        To initiate a request, please contact our support team at <span className="text-[#3EBAA2] font-semibold">support@sitemanifest.com</span> 
        or contact our payment partner, <strong>Paddle.com</strong>, directly.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">4. Processing & Reseller Information</h2>
      <p>
        Our order process is conducted by our online reseller <strong>Paddle.com</strong>. 
        Paddle is the Merchant of Record for all our orders. Paddle provides all 
        customer service inquiries regarding payments and handles all refund transactions. 
        Approved refunds typically take 5–10 business days to appear on your bank statement.
      </p>
    </section>
  </LegalLayout>
);

export default Refund;